import { fitToViewport } from 'components/Graph/GraphApp/helpers/fitToViewport';
import { isNodeVisibleInViewport } from 'components/Graph/GraphApp/helpers/isNodeVisibleInViewport';
import type { GraphRendererPlugin } from 'components/Graph/GraphApp/plugins/GraphRendererPlugin';
import { option, record } from 'fp-ts';
import { identity, pipe } from 'fp-ts/lib/function';
import { isOneOf } from 'utils/isOneOf';

export const fitContentToViewport: GraphRendererPlugin = (pluginInterface) => {
  const fit = () => {
    pipe(
      pluginInterface.getGraphBounds(),
      option.map(fitToViewport(pluginInterface.viewport)),
    );
  };

  pluginInterface.bindGraphCommandEventListener('fitGraphToView', (e) => {
    if (!e.boxId) {
      // nodeBoxes plugin takes care of fitting particular box
      fit();
    }
  });

  pluginInterface.events.addListener('graphDataRendered', (e) => {
    if (e.prevData === null) {
      fit();
    }
  });

  pluginInterface.bindGraphCommandEventListener('ensureNodesInView', (e) => {
    const someNonCloudNodeVisible = pipe(
      pluginInterface.getGraphData().nodes,
      e.strict
        ? identity
        : record.filter(({ type }) => !isOneOf(type, 'cloud', 'transit')),
      record.some(
        isNodeVisibleInViewport(pluginInterface, {
          paddingFactor: e.strict ? 0 : 0.05,
        }),
      ),
    );

    if (!someNonCloudNodeVisible) {
      fit();
    }
  });
};
